import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from 'components/elements/Spinner';
import BasePageWithTopNav from 'components/layout/TopNavigationLayout';
import EditFiltersStep from 'components/widgets/ProjectGroupEdit/EditFiltersStep';
import { useResetForm } from 'hooks/projectGroupEdit/useProjectGroupForm';
import { useDashboardGroupId } from 'state/dashboard';
import { trackPageView } from 'utils/analytics';
import {
  EditSavedSearchPageViewSections,
  EditSavedSearchPageViewSubSections,
  NewSavedSearchPageViewSections,
  NewSavedSearchPageViewSubSections,
} from 'utils/analytics/constants';
import { NEW_GROUP_ID } from 'utils/constants';

const RenderEditStep = () => {
  const { id: projectGroupId } = useParams();
  const [groupId, setGroupId] = useDashboardGroupId();

  const { isDoneReset } = useResetForm(projectGroupId);

  useEffect(() => {
    if (projectGroupId) {
      setGroupId(projectGroupId);
    }
  }, [projectGroupId]);

  useEffect(() => {
    if (!isDoneReset) {
      return;
    }
    if (projectGroupId === NEW_GROUP_ID) {
      trackPageView({
        sectionName: NewSavedSearchPageViewSections.NEW_SEARCH,
        subSectionName: NewSavedSearchPageViewSubSections.NEW_SEARCH,
      });
    } else {
      trackPageView({
        sectionName: EditSavedSearchPageViewSections.EDIT_SEARCH,
        subSectionName: EditSavedSearchPageViewSubSections.EDIT_GROUP + String(groupId),
      });
    }
  }, [String(groupId), isDoneReset]);

  if (!groupId || !isDoneReset) {
    return <Spinner />;
  }

  return <EditFiltersStep />;
};

const ProjectGroupEdit = () => {
  return (
    <BasePageWithTopNav>
      <RenderEditStep />
    </BasePageWithTopNav>
  );
};

export default ProjectGroupEdit;
